/** Paleta global DTE NRS (Tailwind + CSS vars). */
export const APP_COLORS = {
  primary: "#31023C",
  secondary: "#FFFFFF",
  tertiary: "#04B6FD",
};
export const APP_NAME = "DTE<->NRS";

/** `short_name` del manifest (sin caracteres especiales problemáticos). */
export const APP_SHORT_NAME = "DTE NRS";
